import { PressEvent } from '@react-types/shared';
import { UnstyledLinkProps } from '@sparemin/blockhead';
import { useCallback } from 'react';
import { useTracking } from 'state/tracking';
import { useUnit } from 'state/unit';

export interface UsePodcastDestinationConfig {
  onPress?: (e: PressEvent) => void;
}

export type UsePodcastDestinationResult = {
  anchorProps: Pick<
    UnstyledLinkProps<'a'>,
    'href' | 'onPress' | 'rel' | 'target'
  >;
};

export default function usePodcastDestination({
  onPress,
}: UsePodcastDestinationConfig = {}): UsePodcastDestinationResult {
  const unit = useUnit();
  const { trackUnitClickThrough } = useTracking();

  const unitId = unit?.resultId;
  const url = unit?.episode.destUrl;

  const handlePress = useCallback(
    (e: PressEvent) => {
      if (unitId) {
        trackUnitClickThrough({ resultId: unitId });
      }

      onPress?.(e);
    },
    [onPress, trackUnitClickThrough, unitId],
  );

  return {
    anchorProps: {
      href: url,
      onPress: handlePress,
      // see https://sparemin.atlassian.net/browse/SPAR-16975
      // noreferrer not required for podcast destination links
      rel: 'noopener',
      target: '_blank',
    },
  };
}
